import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpParamsUtil} from './utils/httpParams.util';
import {StationDto, StationLazyCategory} from '../../domain/infra/station/station';
import {ChargePointDto} from '../../domain/infra/chargePoint/chargePoint';
import {ChargePointsParams} from './mapMarkerHttp.service';
import {Plug} from '../../domain/infra/plug/plug';

@Injectable({
    providedIn: 'root'
})
export class FrontStationHttpService {
    private readonly resourceLocation: string = '/v2/front/stations';

    constructor(private http: HttpClient) {
    }

    public findByAlias(alias: string, lazyCategories: StationLazyCategory[]): Observable<StationDto> {
        return this.findStationById(alias, lazyCategories);
    }

    public findStation(id: string, categories: StationLazyCategory[]): Observable<StationDto> {
        return this.http.get<StationDto>(`${this.resourceLocation}/${id}`,
            {params: HttpParamsUtil.toHttpParams({categories})});
    }

    public findStationChargePoints(stationId: string, params: ChargePointsParams): Observable<Array<ChargePointDto>> {
        return this.http.get<Array<ChargePointDto>>(`${this.resourceLocation}/${stationId}/chargePoints`,
            {params: HttpParamsUtil.toHttpParams(params)});
    }

    findStationById(stationId: string, categories: Array<StationLazyCategory>): Observable<StationDto> {
        return this.http.get<StationDto>(`${this.resourceLocation}/${stationId}`,
            {params: HttpParamsUtil.toHttpParams({categories})});

    }

    getPlugByChargePointAndType(stationId: string, chargePointId: string, plugType: string) {
        return this.http.get<Plug>(`${this.resourceLocation}/${stationId}/chargePoints/${chargePointId}/plug`,
            {params: HttpParamsUtil.toHttpParams({plugType})});
    }
}
